module.exports = __webpack_public_path__ + "img/equipment.7314249a.png";